var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-2 ta-error",style:({ backgroundColor: '#f44336' }),attrs:{"dark":"","small":""}},[_c('v-avatar',{staticClass:"red darken-4",attrs:{"left":""}},[_vm._v(" C ")]),_vm._v(" No association ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }